// Build out an UpgradeAccountSelector that utilizes the modal component
// Only show the modal if the user has `subscriptionPending` set to true

import { useState } from "react";
import { Modal } from "components/Modal";
import { useUser } from "lib/context/user-context";
import AccountItem from "./AccountItem";
import { CustomModalContent } from "components/Modal/CustomModalContent";
import { Text } from "@zapier/design-system";
import styled from "styled-components";

const Accounts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 20px 0 40px;
`;

export default function UpgradeAccountSelector() {
  const { user } = useUser();
  const [isOpen, setIsOpen] = useState<boolean>(true);

  if (user?.subscriptionPending && isOpen) {
    return (
      <>
        <Modal onClosed={() => setIsOpen(false)}>
          <CustomModalContent>
            <Text type="sectionHeader3">Select an account</Text>
            <Text tag="p" type="paragraph1">
              Choose the account you want to grant Advanced plan access
            </Text>
            <Accounts>
              {user.accounts?.map((account) => (
                <AccountItem
                  account={account}
                  onSelect={() => setIsOpen(false)}
                  key={account.id}
                />
              ))}
            </Accounts>
          </CustomModalContent>
        </Modal>
      </>
    );
  }

  return null;
}
